import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  sectorFilter: [],
  countryFilter: [],
  varietyFilter: [],
  flashColorFilter: [],
  ipOwnerShipFilter: [],
  regionFilter: [],
  laguageFilter: [],
  subjectFilter: [],
  cropTypeFilter: [],
  visibility: [],
  contentLevel: [],
  specialProjects: [],
  contentType: [],
  periods: [],
  disclaimers: [],
  sectorAndCountry: [],
  pageGroupFilter: [],
};

const internalFilter = createSlice({
  name: "internalFilter",
  initialState,
  reducers: {
    setSectorFilter: (state, action) => {
      state.sectorFilter = action.payload;
    },
    setCountryFilter: (state, action) => {
      state.countryFilter = action.payload;
    },
    setVarietyFilter: (state, action) => {
      state.varietyFilter = action.payload;
    },
    setFlashColorFilter: (state, action) => {
      state.flashColorFilter = action.payload;
    },
    setIpOwnerShipFilter: (state, action) => {
      state.ipOwnerShipFilter = action.payload;
    },
    setRegionFilter: (state, action) => {
      state.regionFilter = action.payload;
    },
    setLanguageFilter: (state, action) => {
      state.laguageFilter = action.payload;
    },
    setSubjectFilter: (state, action) => {
      state.subjectFilter = action.payload;
    },

    setCropTypeFilter: (state, action) => {
      state.cropTypeFilter = action.payload;
    },
    setPageGroupFilter: (state, action) => {
      state.pageGroupFilter = action.payload;
    },
    setContentLevel: (state, action) => {
      state.contentLevel = action.payload;
    },
    setVisibility: (state, action) => {
      state.visibility = action.payload;
    },
    setSpecialProjects: (state, action) => {
      state.specialProjects = action.payload;
    },
    setDisclaimers: (state, action) => {
      state.disclaimers = action.payload;
    },
    setPeriods: (state, action) => {
      state.periods = action.payload;
    },
    setSectorAndCountry: (state, action) => {
      // ✅ Check if action.payload is an array
      if (!Array.isArray(action.payload) || action.payload.length === 0) {
        return;
      }

      // ✅ Grouping data by sector
      const groupedData = action.payload.reduce((acc, item) => {
        if (!item?.sector?.name) {
          return acc; // Skip items without sector
        }

        const sectorName = item.sector.name;
        if (!acc[sectorName]) {
          acc[sectorName] = []; // Initialize array if not exists
        }
        acc[sectorName].push({
          id: item.id,
          name: item.name,
          description: item.description,
          active: item.active,
        });

        return acc;
      }, {});

      // ✅ Ensure Redux state is updated correctly
      state.sectorAndCountry = { ...groupedData };
    },
  },
});
export const {
  setCountryFilter,
  setFlashColorFilter,
  setIpOwnerShipFilter,
  setSectorFilter,
  setVarietyFilter,
  setRegionFilter,
  setLanguageFilter,
  setSubjectFilter,
  setCropTypeFilter,
  setVisibility,
  setContentLevel,
  setSpecialProjects,
  setDisclaimers,
  setPeriods,
  setCropType,
  setSectorAndCountry,
  setPageGroupFilter,
} = internalFilter.actions;
export default internalFilter.reducer;
